module.exports = __webpack_public_path__ + "static/media/add.db6750e7.svg";